module.exports = __webpack_public_path__ + "img/gh-202-flpart4.prt.d93e6a7b.jpg";